
import { MapLocation } from '@/types/location';

// Waki Schools in Riyadh region
export const wakiSchoolsRiyadh: MapLocation[] = [
  {
    id: 40025,
    name: "Manarat (Izdihar) - Elementary Male",
    type: "School",
    devices: 1,
    coordinates: [24.7881562, 46.7150608],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Male",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 200
    }
  },
  {
    id: 40026,
    name: "Manarat (Izdihar) - Elementary Female",
    type: "School",
    devices: 2,
    coordinates: [24.7881562, 46.7150608],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 200
    }
  },
  {
    id: 40027,
    name: "Manarat (Izdihar) - Intermediate/Secondary Female",
    type: "School",
    devices: 1,
    coordinates: [24.7881562, 46.7150608],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "12-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40050,
    name: "Kingdom Schools (Riyadh)",
    type: "School",
    devices: 6,
    coordinates: [24.7687, 46.7219],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40051,
    name: "Riyadh Schools",
    type: "School",
    devices: 5,
    coordinates: [24.7427, 46.6691],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40052,
    name: "Al Yasmin International School (Riyadh)",
    type: "School",
    devices: 4,
    coordinates: [24.8256, 46.6365],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40053,
    name: "Almanahel International School (Riyadh)",
    type: "School",
    devices: 3,
    coordinates: [24.7912, 46.7253],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40054,
    name: "Alrowad International School (Riyadh)",
    type: "School",
    devices: 4,
    coordinates: [24.7689, 46.6987],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 41007,
    name: "Manarat (Izdihar) - Riyadh",
    type: "School",
    devices: 3,
    coordinates: [24.788156, 46.715061],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary, Intermediate, Secondary",
      students: 1185
    }
  },
  {
    id: 41016,
    name: "Al-Rowad Private Schools (Izdihar) - Riyadh",
    type: "School",
    devices: 8,
    coordinates: [24.782234, 46.721232],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary, Intermediate, Secondary",
      students: 1153
    }
  },
  {
    id: 41017,
    name: "Joza Educational",
    type: "School",
    devices: 2,
    coordinates: [24.782234, 46.721232],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 349
    }
  },
  {
    id: 41019,
    name: "Dawat Al Uloom School",
    type: "School",
    devices: 3,
    coordinates: [24.698422, 46.609534],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 653
    }
  },
  {
    id: 41026,
    name: "Almanahel (Al Taawoun)",
    type: "School",
    devices: 4,
    coordinates: [24.765916, 46.696262],
    region: "Riyadh",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 1845
    }
  }
];
